module.exports = __webpack_public_path__ + "static/media/Communicate.33c426f6.svg";